import React, { useState } from "react";
import '../../CSS/Visiter.css';
import '../../CSS/evenement_marquant.css';
import BeninInfo from "../composant_reutilisable/BeninInfo";
import Carousel from "../composant_reutilisable/Carousel";
import Africa from '../../images/Africa.svg';
import pr from '../../images/pr.png';
import voyage from '../../images/voyage.png';
import voyage1 from '../../images/voyage1.png';
import Vodun from '../../images/anchinois.png';
import Senum from '../../images/lanterne.png';
import MenuSection from "./menuSection";
import MenuSection1 from "./menuSection1";
import { FaArrowRight } from "react-icons/fa";



const Eventchine = () => {
    const [selectedCategory, setSelectedCategory] = useState("TOUS LES EVENEMENTS");

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
        console.log(`Catégorie sélectionnée: ${category}`);
    };

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">

                <MenuSection1
                    title="EVENEMENTS"
                    subtitle1="TOUS LES EVENEMENTS"
                    subtitle2="CULTURELS"
                    subtitle3="SCIENTIFIQUES"
                    subtitle4="FESTIVALS OU CONCERTS"
                    selectedCategory={selectedCategory}
                    onCategoryClick={handleCategoryClick}
                />

                {/* Premier événement */}
                <div className="affaire-container"
                    style={{
                        backgroundColor: 'transparent',
                        marginTop: '50px'
                    }}
                >
                    <div className="affaires-img">
                        <img src={Vodun} alt="Vodun days" />
                    </div>
                    <div className="affaires-text">
                        <h2 style={{ backgroundColor: '#1a3c5e', color: "#fff", fontWeight: "semi-bold", width: "70%", padding: "5px 10px" }}>
                            LE NOUVEL AN CHINOIS
                        </h2>
                        <p>C'est la fête la plus importante et la plus longue du calendrier chinois.
                            </p>
                        <ul>
                            <li><strong>Signification :</strong>Elle marque le début de la nouvelle année lunaire et le renouveau de la nature (le printemps). C'est le moment ou l'on chasse les mauvais esprits de l'année passée pour accueillir la chance et la prospérité.
                            </li>
                            <li><strong>Traditions :</strong>Les familles se réunissent pour un immense banquet (le diner de veille de Nouvel An), on offre des enveloppes rouges (hongbao) contenant de l'argent et on allume des pétards et feux d'artifice.
                            </li>
                            <li><strong>Symbole :</strong>Le rouge, le dragon et les réunions.
                            </li>
                        </ul>
                        <a className="btn-investo"
                            href="https://vodundays.bj/"
                            target="_blank" rel="noopener noreferrer"
                        >
                            DÉCOUVREZ COMMENT PARTICIPER
                            <FaArrowRight className="btn-icon" />
                        </a>
                    </div>
                </div>

                {/* Séparateur après le premier événement */}
                <hr className="event-separator" />

                {/* Deuxième événement */}
                <div className="affaire-container"
                    style={{
                        backgroundColor: 'transparent',
                        marginTop: '50px'
                    }}
                >
                    <div className="affaires-img">
                        <img src={Senum} alt="Senum" />
                    </div>
                    <div className="affaires-text">
                        <h2 style={{ backgroundColor: '#1a3c5e', color: "#fff", fontWeight: "semi-bold", width: "70%", padding: "5px 10px" }}>
                            LA FÊTE DES LANTERNES</h2>
                        <p>Elle a lieu le 15ème jour du premier mois lunaire, marquant la fin des célébrations du Nouvel An.
                        </p>
                        <ul>
                            <li><strong>Signification :</strong>Elle célèbre la première lune de l'année. C'est un fête de lumière, d'espoir et de retrouvailles.
                            </li>
                            <li><strong>Traditions :</strong>On admire des lanteernes géantes et colorées, on résout des devinettes écrites sur les lanternes et on mange des Tangyuan (petites boules de riz gluant sucrées) qui symbolisent l'unité de la famille par leur forme ronde.
                            </li>
                            <li><strong>Symbole :</strong>Les lanternes illuminées dans la nuit.
                            </li>
                        </ul>
                        <a className="btn-investo"
                            href="https://vodundays.bj/"
                            target="_blank" rel="noopener noreferrer"
                        >
                            DÉCOUVREZ COMMENT PARTICIPER
                            <FaArrowRight className="btn-icon" />
                        </a>

                    </div>
                </div>

                {/* Pas de séparateur après le dernier événement */}
            </div>
        </div>
    );
};

export default Eventchine;